<template lang="html">
    <div class="cc">
        <!-- banner -->
        <div class="qyj-banner">
            <!-- <img width="100%" src="https://static.qyjmed.com/webSite/aboutUs/cc/cc-bg.png" alt=""> -->
        </div>
        <!-- content -->
        <div class="container">
            <h2>ABOUT 彩超</h2>
            <div class="cc-box">
                <div class="cc-text">
                    <i></i>
                    <p data-wow-delay="1s" class="wow bounceInLeft"><b>“彩超技术服务联盟”</b>由全国几十家彩超专业售后服务公司组成，成员均为行业内资深工程师及行业精英，行业服经验15年以上，深谙彩超售后服务运作模式及行业现状。</p>
                    <p data-wow-delay="1s" class="wow bounceInLeft">联盟从技术、配件、管理等方面为成员能提供全方位的运营管理服务及平台。此外，联盟利用自身积累的技术储备和行业资源在全国范围内已成功举办大型专业培训多次，极大推广了业内技术交流，为打造积极健康的行业生态圈奠定了良好的基础。</p>
                </div>
                <div class="cc-img">
                    <img src="https://static.qyjmed.com/webSite/aboutUs/cc/cc.png" alt="">
                </div>
            </div>
            <div class="cc-footer">
                <p data-wow-delay="1s" class="wow zoomInDown">全医佳与“彩超技术服务联盟”携手打造了彩超领域医疗售后行业全国性联盟，成员目前已覆盖十多个省市，全职彩超工程师200余名，配件库储备近亿。至此，全医佳彩超合作联盟已覆盖全品牌全系列所有型号超声设备，累计维修超声设备10万余台次，已为全国一万多家医院倾心服务。</p>
            </div>

        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
  name: 'HeaderTop',
  mounted() {
      var wow=new WOW({
          live: false
      })
      wow.init()
  },
  components: {
      Foot
  }
}
</script>
<style lang="scss" scoped>
    .cc{
        .qyj-banner{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/aboutUs/cc/cc-bg.png') center;
            height: 285px;
        }
        .container{
            h2{
                font-size: 40px;
                color:#1B212B;
                margin:60px 0 42px;
                text-align: center;
            }
            .cc-box{
                .cc-text{
                    width: 600px;
                    height: 490px;
                    display: inline-block;
                    vertical-align: top;
                    background-image: url('https://static.qyjmed.com/webSite/aboutUs/cc/text-bg.png');
                    p{
                        font-size: 18px;
                        color: #333333;
                        line-height: 36px;
                        text-indent: 2rem;
                        padding:0 60px 0 0;
                        &:nth-child(2){
                            margin-top: 50px;
                            margin-bottom: 30px;
                        }
                    }
                    i{
                        width: 47px;
                        height: 7px;
                        display: block;
                        background-color: #79AAF4;
                        margin-top: 53px;
                    }

                }
                .cc-img{
                    width: 600px;
                    display: inline-block;
                }
            }
            .cc-footer{
                height: 400px;
                margin-top: 40px;
                margin-bottom: 80px;
                background: url('https://static.qyjmed.com/webSite/aboutUs/cc/cc-foot.png');
                p{
                    padding:150px 160px 0;
                    color: white;
                    text-indent: 2rem;
                    line-height: 36px;
                    letter-spacing: 1px;
                }
            }
        }
    }
</style>
